<div class="container">
  <app-crypto [cryptoBalances]="cryptoBalances"></app-crypto>
</div>
